import { SettingKey } from '@frontend/setting/types';

import { useAppSelector } from '../../redux/store';
import { useLicenseRepository } from '../../utils/license-repository';

export const useDefaultHome = () => {
    const navigationState = useAppSelector((store) => store.navigation);
    const { functionalities, isLoading } = useLicenseRepository();

    return {
        allowUserIdentification: navigationState.spot?.settings ? !!navigationState.spot.settings[SettingKey.ALLOW_USER_IDENTIFICATION] : false,
        isLoggedIn: navigationState.user !== null,
        display: navigationState.iot?.display,
        functionalities,
        isLoading
    };
};
